import { useEffect, useState } from "react";
import { HairOpenIcon } from "../../icons/HairOpenIcon";
import "./styles.css";
import { IoChevronBackOutline, IoClose, IoHeartOutline } from "react-icons/io5";
import Button from "../../Button/Button";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import { useTranslation } from "react-i18next";

export const ProductCheckoutPage = ({
  selectedFavorite,
  onRemoveFavorite,
  onBackClick,
  onExitClick,
}) => {
  const {t} = useTranslation("recommendation")
  const trackEvent = useAmplitude();
  const { uid } = useUID();
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    trackEvent("webapp_user_visited_products_checkout_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="product-checkout-page">
      <div className="product-checkout-page-nav-header">
        <div className="product-checkout-page-nav">
          <div className="product-checkout-back-button-wrapper">
            <IoChevronBackOutline
              className="product-checkout-back-icon"
              onClick={() => {
                trackEvent(
                  "webapp_user_back_button_products_checkout_page",
                  uid,
                );
                onBackClick();
              }}
            />
          </div>
          <div className="product-checkout-close-button-wrapper">
            <IoClose
              className="product-checkout-close-icon"
              onClick={() => {
                trackEvent(
                  "webapp_user_exit_button_products_checkout_page",
                  uid,
                );
                onExitClick();
              }}
            />
          </div>
        </div>
      </div>
      <div className="product-checkout-contents-container">
        <div className="product-checkout-contents">
          <div className="product-checkout-contents-header">
            <h4 className="product-checkout-header-text">{t("checkoutPage.my-favorites")}</h4>
            <IoHeartOutline className="product-checkout-header-icon" />
          </div>
          <div className="product-checkout-items">
            {selectedFavorite.map((product, index) => (
              <div key={index} className="product-checkout-item">
                <img
                  src={product.image}
                  alt="Favorite Product"
                  className="product-checkout-item-image"
                />
                <IoClose
                  className="product-checkout-item-remove-icon"
                  onClick={() => onRemoveFavorite(product)}
                />
                <h4 className="product-checkout-item-title">{product.title}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="product-checkout-button-container">
        <div className="product-checkout-button">
          <Button
            text={t("checkoutPage.checkout-cta")}
            onClick={() => {
              trackEvent(
                "webapp_user_product_checkout_pressed",
                uid,
                "",
                "",
                "",
                "",
                selectedFavorite.length,
              );
              setShowPopup(true);
            }}
            disabled={selectedFavorite.length < 1}
            alternateColor={true}
          />
        </div>
      </div>

      {showPopup && (
        <div
          className="product-checkout-popup-overlay"
          onClick={() => setShowPopup(false)}
        >
          <div className="product-checkout-popup">
            <HairOpenIcon className={"product-checkout-popup-icon"} />
            <p className="product-checkout-popup-text">
                {t("checkoutPage.popup.description")}
            </p>
            <button
              onClick={() => {
                trackEvent(
                  "webapp_user_product_checkout_completed_pressed",
                  uid,
                  "",
                  "",
                  "",
                  "",
                  selectedFavorite.length,
                );
                setShowPopup(false);
              }}
              className="product-checkout-popup-button"
            >
              {t("checkoutPage.popup.cta")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
